import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagePreviewLibComponent } from './image-preview-lib.component';



@NgModule({
  declarations: [ImagePreviewLibComponent],
  imports: [
    // CommonModule
  ],
  exports: [ImagePreviewLibComponent]
})
export class ImagePreviewLibModule { }
